const loadImage = src =>
  new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = () => {
      const { height, width } = img
      resolve({ height, width })
    }

    img.onerror = reject
    img.src = src
  })

const getImageSize = async ({ image, width, height }) => {
  const imgResult = await loadImage(image)

  const { width: originalWidth, height: originalHeight } = imgResult

  const aspectRatio = originalWidth / originalHeight

  if (width) {
    return { width, height: width / aspectRatio }
  }

  if (height) {
    return { height, width: height * aspectRatio }
  }

  return { width: originalWidth, height: originalHeight }
}

const pixelToDxa = (px, dpi = 150) => {
  const mm = (px * 25.4) / dpi
  const cm = mm / 10
  const dxa = (cm / 2.54) * 72 * 20

  return dxa
}

const pixelToHalfPt = (px, dpi = 150) => {
  const mm = (px * 25.4) / dpi
  const cm = mm / 10
  const dxa = (cm / 2.54) * 72 * 2

  return dxa
}

export { loadImage, getImageSize, pixelToDxa, pixelToHalfPt }
